import { ClientStorage, ClientStorageItem } from "./clientstorage";

let redirectingToLogin = false;

const sessionFailureMessages = new Set([
  "invalid token",
  "no authorization found",
  "your access to this wedding is no longer active",
]);

export const handleUnauthorizedResponse = (
  statusCode: number,
  message?: string,
) => {
  const isSessionFailure =
    statusCode === 401 &&
    sessionFailureMessages.has((message || "").trim().toLowerCase());

  if (!isSessionFailure || redirectingToLogin) return;

  redirectingToLogin = true;
  ClientStorage.delete(ClientStorageItem.AccessToken);
  ClientStorage.delete(ClientStorageItem.UserWeddingRole);
  ClientStorage.delete(ClientStorageItem.XAccountHash);
  ClientStorage.delete(ClientStorageItem.WeddingVersion);
  ClientStorage.store(ClientStorageItem.HasSeenWelcome, "false");

  if (window.location.pathname !== "/login") {
    const currentPath =
      window.location.pathname + window.location.search;
    window.location.replace(
      "/login?session=expired&returnTo=" + encodeURIComponent(currentPath),
    );
  } else {
    redirectingToLogin = false;
  }
};
